import { render, staticRenderFns } from "./comp_FooterLinkList.vue?vue&type=template&id=8c90d520&scoped=true&"
import script from "./comp_FooterLinkList.vue?vue&type=script&lang=js&"
export * from "./comp_FooterLinkList.vue?vue&type=script&lang=js&"
import style0 from "./comp_FooterLinkList.vue?vue&type=style&index=0&id=8c90d520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90d520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
